import React from 'react';
import { Box } from '@mui/material';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Common/Header/Header';
import CensusChartsContainer from './CensusChartsContainer';
import { dashboardPath } from './Consts/sidebar';

/**
 * Aba do dashboard do Censo com submenus (mesmo padrão de IGD > Resultados).
 * `pages`: [{ path, title, element }]; a primeira é a página inicial da aba.
 */
const CensusSection = ({ menuPath, pages }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const basePath = `${dashboardPath}/${menuPath}`;

    const menus = pages.map(({ path, title }) => ({ title, path: `${basePath}/${path}` }));
    const current = pages.find(({ path }) => location.pathname.startsWith(`${basePath}/${path}`)) || pages[0];

    return (
        <Box>
            <Header menus={menus} onHomeClick={() => navigate(dashboardPath)} />
            <Box className="content">
                <CensusChartsContainer title={current.title} className="services-container-dashboards">
                    <Routes>
                        <Route path="/" element={<Navigate to={pages[0].path} replace />} />
                        {pages.map(({ path, element }) => (
                            <Route key={path} path={path} element={element} />
                        ))}
                    </Routes>
                </CensusChartsContainer>
            </Box>
        </Box>
    );
};

export default CensusSection;
